export const environment = {
  production: true,
  baseApiUrl: 'https://demo.gmpro.lsu.edu/api',
  deKey:
    'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjVjZmMyNjRkLTgwYjEtNGMxMy1hMGUwLWQ2OGMxYzdkNGRkYSIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjMyCn0=.smBRsMRiiHAh1Oq9wofTGBbobo9UE410vztqjjC3pEgtjl5EPvJvifoNvjZ8E9SofR5XIse5lhYnNqzExYwxP1542y7MkmGnfCH4DXJAxHhoWbKjkH+qTf6w+KB2Dk5lcyxw8w==',
};
